export const styles = {
  noteTitle: {
    background: '#018544',
  },
  onCreateIcon: {
    color: 'light',
    cursor: 'pointer',
  },
};
